import IRAFooter from '@/components/IRAComp/IRAFooter';
import IRAHeader from '@/components/IRAComp/IRAHeader';
import Image from '@/components/UI/Image';
import SingleBox from '@/components/UI/SingleBox';
import EFAddNew from '@/components/UI/svg/Footer/Icon/EFAddNew';
import EFReduce from '@/components/UI/svg/Footer/Icon/EFReduce';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import EFArrowRightBlueSmall from '@/components/UI/svg/Icons/EFArrowRightBlueSmall';
import EFArrowUp from '@/components/UI/svg/Icons/EFArrowUp';
import EFPureSelectIcon from '@/components/UI/svg/Icons/EFPureSelectIcon';
import EFAffirm from '@/components/UI/svg/mm100/Icon/EFAffirm';
import { FormatMoney, GetUrlParams } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { saveCookieForShopify, saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import { Button } from 'antd';
import { memo, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { hideCountry } from '../..';
import { useDispatch } from '../../context';
import style from './index.module.scss';
import { Terms } from './terms';
const FormatMoneyWrapper = ({ price }: any) => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    let tempStr;

    switch (locale) {
        case 'fr':
        case 'de':
            tempStr = (
                <>
                    {FormatMoney(price, ' ')}&nbsp;
                    {t('unit')}
                </>
            );
            break;
        case 'jp':
            tempStr = (
                <>
                    {t('unit')}&nbsp;
                    {FormatMoney(price)}
                    <span className="sub-unit">(税込)</span>
                </>
            );
            break;
        default:
            tempStr = (
                <>
                    {t('unit')}&nbsp;
                    {FormatMoney(price)}
                </>
            );
            break;
    }

    return tempStr;
};

const needQuoteLangList = ['us', 'uk', 'de', 'fr', 'ca', 'kr'];

const ProductItem = ({ productInfo = {}, buyBtnClick, getAQuoteClick }: any) => {
    const { useLang, gtm, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    const gtmPushData = () => {
        const { name, off_price } = productInfo;
        const result = name.match(/\(([^)]*)\)/);
        const listName = result[1] ? result[1] : 'none';

        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            list_name: listName,
            product_name: name || '',
            price: `${t('unit')}${off_price}`,
            tag: 'none',
            quantity: '1',
            button_name: 'Buy Now',
        });
        window?.fbq?.('track', 'Schedule');
    };

    const buyProduct = () => {
        try {
            gtmPushData();
        } catch (e) {
            console.log(e);
        } finally {
            buyBtnClick('bundleDetail');
        }
    };

    return (
        <div className="product-item">
            <div className="prd-img-wrapper">
                <Image src={productInfo.imgSrc} layout="fill" className="fullImgs" alt={productInfo.name} aria-label={productInfo.name} />
            </div>
            <p className="prd-name">{productInfo.name}</p>

            {locale !== 'au' && (
                <div className="buy-info">
                    <div className="discount">
                        {locale !== 'cn' && (
                            <p>
                                <span className="off-price">
                                    <FormatMoneyWrapper price={productInfo.off_price} />
                                </span>
                                {productInfo.save_money && (
                                    <span className="old-price">
                                        <FormatMoneyWrapper price={productInfo.old_price} />
                                    </span>
                                )}
                            </p>
                        )}
                        {productInfo.save_money && !['us', 'cn'].includes(locale) && (
                            <span className="save-money">
                                {t('presale.bundles.save')}
                                <FormatMoneyWrapper price={productInfo.save_money} />
                            </span>
                        )}
                        {locale === 'cn' && (
                            <>
                                <span className="off-price">{productInfo.off_price}</span>
                            </>
                        )}
                    </div>
                    {locale === 'us' && (
                        <div className="affirm">
                            <span className="icon">
                                <EFAffirm width={'46px'} height={'18px'} />
                            </span>
                            <span className="text">{productInfo.affirm}</span>
                            <Link href="https://www.affirm.com/terms" newWin>
                                Learn More
                                <span className="arrow-icon">
                                    <EFArrowLeft />
                                </span>
                            </Link>
                        </div>
                    )}
                    <div className="place-line"></div>
                </div>
            )}

            <div className="prd-info">
                {!hideCountry.includes(locale) && locale !== 'jp' && (
                    <div className="delivery">
                        <p className="label">{t('presale.bundles.delivery')}:</p>
                        <p className="value">{productInfo.delivery_date}</p>
                    </div>
                )}
                <div className="accessories">
                    <p className="label">{t('presale.bundles.include')}:</p>
                    {productInfo?.accessories?.map((item: string, indx: number) => (
                        <p key={indx} className="value">
                            {item}
                        </p>
                    ))}
                </div>
            </div>

            <div className="btns">
                <Button type="primary" className="order-btn" onClick={buyProduct}>
                    {t('presale.bundles.buynow')}
                </Button>
                {needQuoteLangList.includes(locale) && (
                    <div className="geta_quote" onClick={() => getAQuoteClick(productInfo.name)}>
                        <span>{t('presale.preorder.preordernow')}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

const BundleDetail = ({
    backBtnClick,
    detailData,
    solarPanelData,
    batteryData,
    purcharseUrl,
    installationData,
    consoleData,
    smartGeneratorData,
    getAQuoteClick,
}: any) => {
    const { useLang, useState, useEffect, gtm, useRouter, Link } = useGlobal();

    const { locale } = useRouter();

    const dispatch = useDispatch();

    const { t } = useLang('ecoflowpowerkitsseries');

    // 购物车待结算相关总额
    const [cartSum, setCartSum] = useState({
        oldPrice: '',
        offPrice: '',
        saveMoney: '',
    });

    // 待选择电池列表
    const [batteryList, setBatteryList] = useState([]);

    // 待选择console产品
    const [consoleList, setConsoleList] = useState([]);

    // 被添加进购物车中商品数据
    const [cartProductMap, setCartProductMap] = useState({});

    // 选择安装方式是否已选择（结算时此项为必选项）
    const [hasSelecedtInstall, setHasSeletedInstall] = useState(false);

    // 选择安装方式文本
    const [selectedInstallText, setSelectedInstallText] = useState('');

    // 产品依赖列表
    const [productDepList, setProductDepList] = useState([]);

    const [hasCookieFooter, setHasCookieFooter] = useState(false);
    const [cookieFooterH, setCookieFooterH] = useState(0);

    let disableCheck = false;

    const checkBundle = () => {
        if (disableCheck) return;
        disableCheck = true;
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_checkout',
            type: selectedInstallText || 'none',
            button_name: 'Checkout',
        });
        window?.fbq && window?.fbq('track', 'SubmitApplication');
        if (hasSelecedtInstall === false && Object.keys(installationData).length > 0) {
            const installEl = document.querySelector('.bundle-installation') as HTMLElement;
            return installEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        let tempParams = '';
        for (const [key, value] of Object.entries(cartProductMap)) {
            if (value.num === 0) {
                continue;
            }
            tempParams += `${key}:${value.num},`;
        }
        tempParams = tempParams.slice(0, -1);
        const cartUrl = `${purcharseUrl}cart/${tempParams}?channel=buy_button`;
        saveCookieForShopify(cartUrl, locale);
        saveAICookieForShopify(cartUrl, locale);
        // 增加name是为了防止点击打开多个购买页面
        window.open(cartUrl, 'calculators_mm100_shopify');
        setTimeout(() => {
            disableCheck = false;
        }, 1000);
    };

    const getCartUrl = useCallback(() => {
        let tempParams = '';
        for (const [key, value] of Object.entries(cartProductMap)) {
            if (value.num === 0) {
                continue;
            }
            tempParams += `${key}:${value.num},`;
        }
        tempParams = tempParams.slice(0, -1);
        return `${purcharseUrl}cart/${tempParams}?channel=buy_button`;
    }, [cartProductMap]);

    const changeCartProductMap = (data: any) => {
        let tempMap = {
            ...cartProductMap,
        };
        tempMap[data.varId] = {
            oldPrice: data.old_price,
            offPrice: data.off_price,
            saveMoney: data.save_money,
            num: data.num,
            depNode: data.depNodeName,
        };
        if (data.discount) {
            tempMap[data.varId].discount = data.discount;
        }
        // 判断该节点是否是被依赖节点，如果是，则判断改节点是需要从依赖列表中插入还是删除
        if (data.beDepNodeName) {
            const tempDepList = [...productDepList];
            const nodeIndx = tempDepList.indexOf(data.beDepNodeName);
            // 根据num数量判断是插入还是删除
            if (data.num === 0 && nodeIndx !== -1) {
                // 该被依赖节点被删除
                tempDepList.splice(nodeIndx, 1);
                setProductDepList(tempDepList);
                // 删除依赖该节点的节点
                tempMap = updateProductCartByDep(tempMap, data.beDepNodeName);
            }
            if (data.num !== 0 && nodeIndx === -1) {
                // 该被依赖节点name需要插入到依赖列表中
                tempDepList.push(data.beDepNodeName);
                setProductDepList(tempDepList);
            }
        }
        setCartProductMap(tempMap);
    };

    const updateProductCartByDep = (cartMap: any, dep: string) => {
        const tempCart = {
            ...cartMap,
        };
        Object.keys(tempCart).forEach((item: any) => {
            if (tempCart[item].depNode === dep) {
                tempCart[item] = null;
            }
        });
        return tempCart;
    };

    // 设置购物车的展示金额
    useEffect(() => {
        if (detailData.varId) {
            const tempMap = {
                ...cartProductMap,
            };
            tempMap[detailData.varId] = {
                oldPrice: detailData.old_price,
                offPrice: detailData.off_price,
                saveMoney: detailData.save_money,
                num: 1,
            };
            setCartProductMap(tempMap);
        }
    }, [detailData]);

    // 根据购物车中商品数据生成对应的购物车总额
    useEffect(() => {
        if (Object.keys(cartProductMap).length > 0) {
            let oldPrice = 0;
            let offPrice = 0;
            Object.keys(cartProductMap).forEach((item: any) => {
                const temp = cartProductMap[item];
                // 当值为空是跳过该项
                if (!temp) return;
                oldPrice = Number(temp.oldPrice) * temp.num + oldPrice;
                offPrice = Number(temp.offPrice) * temp.num + offPrice;
            });
            setCartSum({
                oldPrice: oldPrice,
                offPrice: offPrice,
                saveMoney: (oldPrice * 1000 - offPrice * 1000) / 1000,
            });
        }
    }, [cartProductMap]);

    // 展示可供选择电池相关信息
    useEffect(() => {
        if (detailData.adaptBatCap && batteryData.length > 0) {
            const temp = batteryData.filter((item: any) => {
                return item.capacity === detailData.adaptBatCap;
            });
            const ntemp = temp.map((item: any) => {
                const tempItem = {
                    ...item,
                    limit: detailData.limit,
                };
                return tempItem;
            });
            setBatteryList(ntemp);
        } else {
            setBatteryList([]);
        }
    }, [batteryData, detailData]);

    // 展示可供选择console产品相关信息
    useEffect(() => {
        if (detailData.consoleChoose === 'Y') {
            setConsoleList(consoleData);
        } else {
            setConsoleList([]);
        }
    }, [detailData]);

    const [swiper, setSwiper] = useState(null);

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== active) {
            swiper?.slideTo(index);
        }
    };

    const [active, setActive] = useState(0);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    setHasCookieFooter(entry.isIntersecting);
                },
                { threshold: 0.5 },
            );

            const kaamelAlertBigNew = document.querySelector('#kaamelAlertBigNew') as HTMLDivElement;
            if (kaamelAlertBigNew) {
                observer.observe(kaamelAlertBigNew);
            }

            return () => {
                observer.disconnect();
            };
        }
    }, []);

    useEffect(() => {
        const kaamelAlertBigNew = document.querySelector('#kaamelAlertBigNew') as HTMLDivElement;
        setCookieFooterH(hasCookieFooter ? kaamelAlertBigNew?.offsetHeight : 0);
    }, [hasCookieFooter]);

    return (
        <div className={style.bundleDetail}>
            <div className="back-btn">
                <p
                    onClick={() => {
                        backBtnClick('bundleList');
                    }}
                    className="btn-wrapper"
                >
                    <span className="back-icon">
                        <EFArrowRightBlueSmall />
                    </span>
                    {t('presale.bundles.back')}
                </p>
            </div>
            <div className="bundle-detail-wrapper">
                <div className="detail-img-list">
                    <div className="sticy-detailimg">
                        <Swiper
                            className="m100-preview-swiper"
                            initialSlide={0}
                            preloadImages={false}
                            lazy={true}
                            centeredSlides={true}
                            grabCursor={true}
                            navigation={true}
                            onSwiper={(swiper: any) => setSwiper(swiper)}
                            onSlideChange={(swiper: any) => setActive(swiper?.activeIndex)}
                        >
                            {detailData.detailImgList?.map((item: any, k: number) => (
                                <SwiperSlide key={k}>
                                    <Image className="step7-swiper-item-img fullImgs" src={`/img/calculators/mm100/${item}`} width={631} height={631} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        {
                            <ul className="small-imgs">
                                {detailData.detailImgList.map((img: any, k: number) => (
                                    <li className={`small-img ${k === active ? 'active' : ''}`} key={k} onClick={() => onSwiperSlideTo(k)}>
                                        <div className="img-box">
                                            <Image src={`/img/calculators/mm100/${img}`} className="fullImgs" layout="fill" />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        }
                    </div>
                </div>
                <div className="bundle-accessories">
                    <h3 className="bundle-title">{detailData.name}</h3>
                    <p className="fits-list">{detailData.desc}</p>
                    <div className="includs">
                        <p className="includs-title">{t('presale.bundles.include')}</p>
                        {detailData?.accessories?.map((item: string, indx: number) => (
                            <p key={indx} className="includs-item">
                                {item}
                            </p>
                        ))}
                    </div>
                    {Object.keys(installationData).length > 0 && ['us', 'ca'].includes(locale) && (
                        <div className={`${style.installation} bundle-installation`}>
                            <InstallationSelect
                                proName={detailData.name}
                                getAQuoteClick={getAQuoteClick}
                                installationData={installationData}
                                installationFunc={(data: any) => {
                                    setHasSeletedInstall(true);
                                    if (data) {
                                        changeCartProductMap(data);
                                    }
                                }}
                                setText={setSelectedInstallText}
                            />
                        </div>
                    )}
                    {batteryList?.length > 0 && (
                        <div className="battery">
                            <p className="name">{t('presale.bundles.batterydesc')}</p>
                            <p className="tips">{t('presale.bundles.batterytips')}</p>
                            {batteryList?.map((item: any, indx: number) => {
                                return (
                                    <div key={`${indx}i`} className="shoppingbox-wrapper">
                                        <ShoppingBox
                                            shoppingData={item}
                                            addProduct={(data: any) => changeCartProductMap(data)}
                                            listName={t('presale.bundles.batterydesc')}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {consoleList?.length > 0 && (
                        <div className="battery">
                            <p className="name">{t('presale.bundles.consoletitle')}</p>
                            {consoleList?.map((item: any, indx: number) => (
                                <div key={`${indx}k`} className="shoppingbox-wrapper">
                                    <ShoppingBox
                                        shoppingData={item}
                                        addProduct={(data: any) => changeCartProductMap(data)}
                                        listName={t('presale.bundles.consoletitle')}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {smartGeneratorData?.length > 0 && (
                        <div className="battery">
                            <p className="name">Be power-ready for any emergency.</p>
                            {smartGeneratorData?.map((item: any, indx: number) => {
                                return (
                                    <div key={`${indx}k`} className="shoppingbox-wrapper">
                                        <ShoppingBox
                                            shoppingData={item}
                                            addProduct={(data: any) => changeCartProductMap(data)}
                                            listName="Be power-ready for any emergency."
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {Object.keys(installationData).length > 0 && !['us', 'ca'].includes(locale) && (
                        <div className={`${style.installation} bundle-installation`}>
                            <InstallationSelect
                                installationData={installationData}
                                installationFunc={(data: any) => {
                                    setHasSeletedInstall(true);
                                    if (data) {
                                        changeCartProductMap(data);
                                    }
                                }}
                                setText={setSelectedInstallText}
                            />
                        </div>
                    )}

                    <div className="solor-panel">
                        <p className="name">
                            {t('presale.bundles.gosolar')}
                            {locale === 'us' && (
                                <Link href="https://blog.ecoflow.com/us/guide-to-the-federal-solar-tax-credit/" newWin>
                                    Learn More
                                    <span className="arrow-icon">
                                        <EFArrowLeft />
                                    </span>
                                </Link>
                            )}
                        </p>
                        {solarPanelData?.map((item: any, indx: number) => {
                            return (
                                <div key={`${indx}j`} className="shoppingbox-wrapper">
                                    <ShoppingBox
                                        shoppingData={item}
                                        addProduct={(data: any) => {
                                            changeCartProductMap(data);
                                        }}
                                        listName={t('presale.bundles.gosolar')}
                                    />
                                </div>
                            );
                        })}
                    </div>
                    {needQuoteLangList.includes(locale) && !['us', 'ca'].includes(locale) && (
                        <div className="geta_quote">
                            <p className="quote-tips">{t('presale.bundles.geta_quote_tips')}</p>
                            <button
                                className="open-quote"
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'click_get_a_quote',
                                        product_name: 'EcoFlow Power Kits',
                                        option_name: detailData.name,
                                        position: 'checkout',
                                    });
                                    dispatch({ type: 'openQuote' });
                                }}
                            >
                                {t('presale.bundles.geta_quote_btn_text')}
                                <EFArrowUp />
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <div className={`cart-wrapper ${cartSum.saveMoney === 0 ? 'noDiscount' : ''}`} style={{ bottom: `${cookieFooterH}px` }}>
                <div className="cart">
                    <div className="place-holder"></div>
                    {locale === 'us' && (
                        <div className="paypal affirmIcon">
                            <div className="icon">
                                <EFAffirm />
                            </div>
                            <span className="desc-tips">{detailData.affirm}</span>
                            <Link href="https://www.affirm.com/terms" newWin>
                                Learn More
                                <span className="arrow-icon">
                                    <EFArrowLeft />
                                </span>
                            </Link>
                        </div>
                    )}
                    <div className="cart-price">
                        <p>
                            <span className="off-price">
                                <FormatMoneyWrapper price={cartSum.offPrice} />
                            </span>
                            {cartSum.saveMoney !== 0 && (
                                <span className="old-price">
                                    <FormatMoneyWrapper price={cartSum.oldPrice} />
                                </span>
                            )}
                        </p>
                        {cartSum.saveMoney !== 0 && (
                            <span className="save-money">
                                {t('presale.bundles.save')}
                                <FormatMoneyWrapper price={cartSum.saveMoney} />
                            </span>
                        )}
                    </div>
                    <div>
                        <Button
                            type="primary"
                            className={`check-btn${hasSelecedtInstall === false && Object.keys(installationData).length > 0 ? ' unablecheck' : ''}`}
                            onClick={checkBundle}
                        >
                            {t('presale.bundles.checkout')}
                        </Button>
                        <span
                            style={{
                                display: 'inline-block',
                                width: 0,
                                height: 0,
                                overflow: 'hidden',
                            }}
                        >
                            {getCartUrl()}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ShoppingBox = ({ shoppingData, addProduct, listName = 'none' }: any) => {
    const { useLang, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    const [shoppingNum, setShoppingNum] = useState(0);

    // 最大购买量
    const [maxNum, setMaxNum] = useState(1);

    // // 减少num按钮状态("1": 表示不可减少，"2": 表示可减少)
    const [reduceStatus, setReduceStatus] = useState(1);

    // // 增加num按钮状态("1": 表示不可增加，"2": 表示可增加)
    const [addNumStatus, setAddNumStatus] = useState(2);

    useEffect(() => {
        if (shoppingData.limit) {
            setMaxNum(shoppingData.limit);
        }
    }, [shoppingData]);

    const changeNum = (e: React.BaseSyntheticEvent) => {
        const tempVal = e.target.value.replace(/[^\d]/g, '');
        const inputNum = Number(tempVal);
        if (inputNum > maxNum || inputNum < 0) return;
        setShoppingNum(String(inputNum)); // 去掉数字前面的0，比如01，02等
        addProduct({
            ...shoppingData,
            num: inputNum,
        });
    };

    useEffect(() => {
        const temNum = Number(shoppingNum);
        if (temNum === maxNum) {
            setAddNumStatus(1);
        } else {
            setAddNumStatus(2);
        }
        if (temNum === 0) {
            setReduceStatus(1);
        } else {
            setReduceStatus(2);
        }
    }, [shoppingNum]);

    const reduceNum = () => {
        const { name, off_price } = shoppingData;
        const quantity = shoppingNum - 1 >= 0 ? shoppingNum - 1 : 0;

        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_remove_from_cart',
            list_name: listName,
            product_name: name || '',
            price: `${t('unit')}${off_price}`,
            tag: 'none',
            quantity,
            button_name: 'remove',
        });
        if (reduceStatus === 1) return;
        const newNum = Number(shoppingNum) - 1;
        if (newNum < 0) return;
        setShoppingNum(newNum);
        addProduct({
            ...shoppingData,
            num: newNum,
        });
    };

    const addNum = () => {
        const { name, off_price } = shoppingData;
        const quantity = shoppingNum + 1;

        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            list_name: listName,
            product_name: name || '',
            price: `${t('unit')}${off_price}`,
            tag: 'none',
            quantity,
            button_name: 'add',
        });
        if (addNumStatus === 1) return;
        const newNum = Number(shoppingNum) + 1;
        if (newNum > maxNum) return;
        setShoppingNum(newNum);
        addProduct({
            ...shoppingData,
            num: newNum,
        });
    };

    return (
        <div className={`${style.shoppingBox} shopping-box ${shoppingNum > 0 ? 'selected' : ''}`}>
            <div className="prd-info">
                <div className="prd-img">
                    <Image src={shoppingData.imgSrc} layout="fill" className="fullImgs" alt={shoppingData.name} aria-label={shoppingData.name} />
                </div>
                <div className="prd-price">
                    <p className="prd-name">{shoppingData.name}</p>
                    <p className="price">
                        <span className="off-price">
                            <FormatMoneyWrapper price={shoppingData.off_price} />
                        </span>
                        {shoppingData.save_money && (
                            <span className="old-price">
                                <FormatMoneyWrapper price={shoppingData.old_price} />
                            </span>
                        )}
                    </p>
                    {shoppingData.save_money && (
                        <p className="save-money">
                            {t('presale.bundles.save')}
                            <FormatMoneyWrapper price={shoppingData.save_money} />
                        </p>
                    )}
                    {shoppingData.tips && <p className="tips">{shoppingData.tips}</p>}
                </div>
            </div>
            <div className="add-remove">
                <div></div>
                <div className="wrapper">
                    <span onClick={reduceNum} className={`remove-icon ${reduceStatus === 1 ? 'forbid' : ''}`}>
                        <EFReduce />
                    </span>
                    <input onChange={changeNum} className="shopping-num" type="text" value={shoppingNum} />
                    <span onClick={addNum} className={`add-icon ${addNumStatus === 1 ? 'forbid' : ''}`}>
                        <EFAddNew />
                    </span>
                </div>
            </div>
        </div>
    );
};

const InstallationSelect = ({ installationFunc, installationData, setText, getAQuoteClick, proName }: any) => {
    const { useState, useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const [selectItem, setSelectItem] = useState(null);
    const { t } = useLang('ecoflowpowerkitsseries');
    const { t: s } = useLang('shared');

    return (
        <div className="section-list">
            <p className="installation-title">
                {s('calculators.mm100.step4.installation')}
                <span className="must-tips">*</span>
            </p>
            <div
                className={`section ${selectItem === '1' ? 'selected' : ''}`}
                onClick={() => {
                    setSelectItem('1');
                    installationFunc({
                        ...installationData,
                        num: 0,
                    });
                    setText(t('presale.bundles.installbymyself'));
                }}
            >
                <div className="select-text">
                    <p className="title">{t('presale.bundles.installbymyself')}</p>
                    {['us', 'ca'].includes(locale) && (
                        <p className="desc">
                            {t.rich('presale.bundles.installbymyselfdesc', {
                                line: (text: string) => (
                                    <Link href="/support/videos" className="turial_video" newWin>
                                        {text}
                                    </Link>
                                ),
                            })}
                        </p>
                    )}
                </div>
                {selectItem === '1' && (
                    <div className="select-icon">
                        <EFPureSelectIcon />
                    </div>
                )}
            </div>
            {['us', 'ca'].includes(locale) && (
                <div className="getQuoteBox">
                    {t.rich('presale.bundles.getaquote', {
                        line: (text: string) => (
                            <span
                                className="quoteLink"
                                onClick={() =>
                                    getAQuoteClick({
                                        name: proName,
                                        position: t('presale.bundles.checkout'),
                                    })
                                }
                            >
                                {text}
                            </span>
                        ),
                    })}
                    {locale === 'us' && (
                        <Link className="nearby" href="/where-to-buy">
                            {t('presale.bundles.nearby')}
                        </Link>
                    )}
                </div>
            )}
            {!['us', 'ca'].includes(locale) && (
                <div
                    className={`section ${selectItem === '2' ? 'selected' : ''}`}
                    onClick={() => {
                        setSelectItem('2');
                        installationFunc({
                            ...installationData,
                            num: 1,
                        });
                        setText(t('presale.bundles.expertinstallation'));
                    }}
                >
                    <div className="select-text">
                        <p className="title">{t('presale.bundles.expertinstallation')}</p>
                        <p className="desc">{locale !== 'us' && t('presale.bundles.expertinstallationdesc')}</p>
                    </div>
                    {selectItem === '2' && (
                        <div className="select-icon">
                            <EFPureSelectIcon />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

function BundleChild({
    activityId,
    activeTab,
    productMap = {},
    solarPanelMap = {},
    BatteryMap = {},
    shopifyUrl,
    installationMap,
    consoleMap,
    smartGeneratorMap,
    preCallback,
}: any) {
    const { useEffect, useState, gtm, useRouter } = useGlobal();
    const dispatch = useDispatch();
    const { locale } = useRouter();

    const standardList: string[] = ['cn'].includes(locale)
        ? ['2度电', '4度电', '5度电', '10度电', '15度电']
        : ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)
        ? ['2 kWh', '4 kWh', '5 kWh', '10 kWh', '15 kWh']
        : ['2kWh', '4kWh', '5kWh', '10kWh', '15kWh'];

    let allPrdList: any = [];

    let defaultproductList = [];

    let solarPanelData = [];

    let batteryData: any = [];

    let consoleData: any = [];

    let installationData: any = {};

    let smartGeneratorData: any = [];

    if (productMap && activityId) {
        allPrdList = productMap[activityId];
        defaultproductList = allPrdList && allPrdList[standardList[0]];
    }
    if (solarPanelMap) {
        solarPanelData = solarPanelMap[activityId];
    }

    if (BatteryMap) {
        batteryData = BatteryMap[activityId];
    }
    if (installationMap) {
        installationData = installationMap[activityId];
    }
    if (consoleMap) {
        consoleData = consoleMap[activityId];
    }
    if (smartGeneratorMap) {
        smartGeneratorData = smartGeneratorMap[activityId];
    }

    useEffect(() => {
        const backBtnEl = document.querySelector('.backToTopBtn') as HTMLElement;
        if (backBtnEl) {
            backBtnEl.style.display = activeTab === 'bundles' ? 'none' : 'unset';
        }
    }, [activeTab]);

    const [productList, setProductList] = useState(defaultproductList);
    const [bundleStatus, setBundleStatus] = useState('bundleList');
    // 购买tab的bundle详情数据
    const [bundleDetail, setBundleDetail] = useState({});
    // 中国站
    const [showDetailsModal_CN, setShowDetailsModal_CN] = useState(false);

    const switchStandard = (value: string) => {
        if (standardList.indexOf(value) !== -1) {
            setProductList(allPrdList[value]);
        }
    };

    const params = GetUrlParams('params');
    const [defaultSelect, setDefaultSelect] = useState(params || standardList[0]);
    useEffect(() => {
        setDefaultSelect(params);
        switchStandard(params);
        if (params) {
            preCallback?.('1');
        }
    }, []);

    return (
        <div className={style.bundles}>
            <div className="bundle-wrapper">
                <div
                    style={{
                        display: bundleStatus === 'bundleList' ? 'block' : 'none',
                    }}
                    className={`bundles-container ${locale === 'us' && ['5kWh', '10kWh', '15kWh'].includes(defaultSelect) ? 'show-ira' : ''} ${
                        locale === 'us' && !['5kWh', '10kWh', '15kWh'].includes(defaultSelect) ? 'hide-ira' : ''
                    }`}
                >
                    <div
                        className="standard-list"
                        style={locale === 'us' && ['5kWh', '10kWh', '15kWh'].includes(defaultSelect) ? { marginBottom: '14px' } : {}}
                    >
                        <div className="standard-wrapper">
                            <SingleBox
                                list={standardList}
                                defaultSelect={defaultSelect}
                                selectFn={(value: string) => {
                                    setDefaultSelect(value);
                                    switchStandard(value);
                                }}
                            />
                        </div>
                    </div>
                    {locale === 'us' && ['5kWh', '10kWh', '15kWh'].includes(defaultSelect) && <IRAHeader borderRadius="12px" top={125} isMM100={true} />}
                    {locale === 'us' && ['5kWh', '10kWh', '15kWh'].includes(defaultSelect) && <div style={{ marginBottom: '38px' }}></div>}
                    <div className="prd-list">
                        {productList?.map((item: any) => (
                            <ProductItem
                                key={item.varId}
                                productInfo={item}
                                buyBtnClick={(value: string) => {
                                    if (locale === 'cn') {
                                        // 中国站： 购买详情页模块（CN站不上，改为弹窗二维码）
                                        setShowDetailsModal_CN(true);
                                    } else if (locale === 'au') {
                                        window.open(item.buy_link, '_blank');
                                    } else {
                                        setBundleDetail(item);
                                        setBundleStatus(value);
                                        const bundleEl = document.querySelector('.space-line') as HTMLElement;
                                        window.scrollTo({
                                            top: bundleEl.offsetTop,
                                        });
                                    }
                                }}
                                getAQuoteClick={(name: string) => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'click_get_a_quote',
                                        product_name: 'EcoFlow Power Kits',
                                        option_name: name,
                                        position: 'buy now',
                                    });
                                    dispatch({ type: 'openQuote' });
                                }}
                            />
                        ))}
                    </div>
                </div>
                {showDetailsModal_CN && (
                    <div className="detailsModal_CN">
                        <div className="mask"></div>
                        <div className="modelBox">
                            <span className="close" onClick={() => setShowDetailsModal_CN(false)}>
                                &times;
                            </span>
                            <p className="title">正浩EcoFlow</p>
                            <p className="text">扫描二维码，添加我的企业微信</p>
                            <div className="qrCodeImg">
                                <Image src="/img/common/qrCode_EF.jpg" layout="fill" className="qrCode qrCode_cn" alt="二维码" aria-label="二维码" />
                            </div>
                            <div className="closeBtn" onClick={() => setShowDetailsModal_CN(false)}>
                                关闭
                            </div>
                        </div>
                    </div>
                )}
                {bundleStatus === 'bundleDetail' && (
                    <div className="bundle-detail">
                        <BundleDetail
                            detailData={bundleDetail}
                            backBtnClick={(value: string) => {
                                setBundleStatus(value);
                            }}
                            solarPanelData={solarPanelData}
                            batteryData={batteryData}
                            installationData={installationData}
                            purcharseUrl={shopifyUrl}
                            consoleData={consoleData}
                            smartGeneratorData={smartGeneratorData}
                            getAQuoteClick={({ name, position = 'buy now', product_name = 'EcoFlow Power Kits' }: { [k: string]: string }) => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'click_get_a_quote',
                                    product_name,
                                    option_name: name,
                                    position,
                                });
                                dispatch({ type: 'openQuote' });
                            }}
                        />
                    </div>
                )}
                {locale === 'us' && <Terms />}
                {locale === 'us' && !['5kWh', '10kWh', '15kWh'].includes(defaultSelect) && <div style={{ paddingBottom: '40px' }}></div>}
                {locale === 'us' && ['5kWh', '10kWh', '15kWh'].includes(defaultSelect) && (
                    <IRAFooter borderTopColor="#ebe9e9" titleColor="#777" bgColor="#fff" boxStyle={{ width: '1120px', paddingTop: '40px' }} />
                )}
            </div>
        </div>
    );
}

const MemoBundles = memo(BundleChild);

export default function Bundles({ activityId, activeTab, preCallback }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const BundleData = require(`@/data/powerkit/${locale || 'us'}`);

    return (
        <MemoBundles
            activityId={activityId}
            activeTab={activeTab}
            productMap={BundleData.ProductMap}
            solarPanelMap={BundleData.solarPanelMap}
            BatteryMap={BundleData.BatteryMap}
            installationMap={BundleData.InstallationMap}
            consoleMap={BundleData.ConsoleMap}
            shopifyUrl={BundleData.ShopifyUrl}
            smartGeneratorMap={BundleData.SmartGenerator || null}
            preCallback={preCallback}
        />
    );
}
